module.exports = __webpack_public_path__ + "228f4a213c71784ff4675f7edc65599d.eot";


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-toastr/src/fonts/redux-toastr.eot
// module id = 395
// module chunks = 0 1